import { convertTsToLocal } from '../../../../../../../utils/displayTime';

const refinedObj = (item, val, key) => {
    let newObj = {
        entry_ts: convertTsToLocal(item.entry_ts),
        [key]: item[val],
        anomaly: item[`${val}_anomaly`],
        sla: item[`daily_sla_classes_static_baseline_${val}`],
        std: item[`daily_${val}_std_dev`],
        Baseline: item[`daily_${val}_mean`]
    };
    return newObj;
}

export const getTrendChartData = (APires) => {
    let Loss = [], Latency = [], Jitter = [], Usage = [];
    APires.forEach(item => {
        Loss.push(refinedObj(item, 'loss_percentage', 'Loss'));
        Latency.push(refinedObj(item, 'latency', 'Latency'));
        Jitter.push(refinedObj(item, 'jitter', 'Jitter'));
        Usage.push({ 
            entry_ts: convertTsToLocal(item.entry_ts), 
            Usage: item.app_usage,
            tooltip: item.display_app_usage,
         });
    });

    return [ {id: 'Loss', data: Loss},
        {id: 'Latency', data: Latency},
        {id: 'Jitter', data: Jitter}, 
        {id: 'Usage', data: Usage} ];
};

